import { Box, Input, withStyles } from '@material-ui/core';
import { InputProps } from '@material-ui/core/Input/Input';
import React, { FC } from 'react';
import { SearchIcon } from '../../../assets/img/SearchIcon';

export type SearchFieldProps = Omit<InputProps, 'disableUnderline' | 'text'> & {
  minWidth?: string;
};

const ImgContainer = withStyles((theme) => ({
  root: {
    border: `solid 1px ${theme.palette.primary.main}`,
    float: 'right',
    width: 40,
    height: 40,
    color: theme.palette.primary.main,
    padding: '8px',
  },
}))(Box);

const CustomTextField = withStyles<'root', any, SearchFieldProps>({
  root: {
    minWidth: ({ minWidth }) => minWidth ?? '350px',
    paddingLeft: '10px',
    paddingRight: '10px',
    borderBottom: '1px solid #787878',
    '&>input::placeholder': {
      fontStyle: 'italic!important',
    },
  },
})(Input);

export const SearchField: FC<SearchFieldProps> = (props) => (
  <Box display='inline-flex' bgcolor='white'>
    <CustomTextField {...props} disableUnderline={true} type='text' />
    <ImgContainer>
      <SearchIcon width={24} height={24} />
    </ImgContainer>
  </Box>
);
